import { v4 as uuidv4 } from 'uuid'
import create from '../creator'
import { checkIOs, checkMacOS, checkIsChrome, isDesktop } from '@/utils/helpers'

import scrollLocker from '@/utils/scrollLocker'

const initialState = () => ({
	isSidebarVisible: false,
	mainErrors: [],
	modalsList: [],
	isMobileScreen: false,
	isScreenMore575: false,
	isScreenMore480: false,
	isForcedDarkChrome: false,
	isDarkFromOS: false,
	isDesktopDevice: false,
	isIOS: false,
	isChrome: false,
	isMacOrIOS: false,
	isNavAutoScroll: false,
	isScrollLocked: false,
	bodyScrollTopPosition: 0
})
const state = initialState()

const actions = {
	toggleSidebarVisibility({ commit, dispatch }) {
		commit('toggleSidebarVisibility')
		dispatch('toggleSidebarClassToBody')
	},

	hideSidebar({ commit, dispatch }) {
		commit('hideSidebar')
		dispatch('toggleSidebarClassToBody')
	},

	addMainError({ commit }, message) {
		commit('addMainError', message)
	},

	removeMainError({ commit }, id) {
		commit('removeMainError', id)
	},

	hideModal({ commit }, name) {
		commit('hideModal', name)
	},

	setIsMobileScreen({ commit }, value) {
		commit('setIsMobileScreen', value)
	},

	setIsScreenMore575({ commit }, value) {
		commit('setIsScreenMore575', value)
	},

	setIsScreenMore480({ commit }, value) {
		commit('setIsScreenMore480', value)
	},

	detectUserPlatform({ commit }) {
		const isIos = checkIOs()
		commit('setIsMacOrIos', isIos || checkMacOS())
		commit('setIsIos', isIos)
		commit('setIsChrome', checkIsChrome())
	},

	setIsDesktopDevice({ commit }) {
		commit('setIsDesktopDevice', isDesktop())
	},

	toggleSidebarClassToBody({ state }) {
		const body = document.querySelector('body')

		if (state.isSidebarVisible) {
			body.classList.add('sidebar-visible')
		} else {
			body.classList.remove('sidebar-visible')
		}
	},

	startNavAutoScroll({ commit }) {
		commit('setNavAutoScroll', true)
	},

	stopNavAutoScroll({ commit }) {
		commit('setNavAutoScroll', false)
	},

	lockScroll({ commit, state }) {
		if (state.isScrollLocked) {
			return
		}

		const scrollPosition = scrollLocker.getBodyScrollPosition()

		commit('setCurrentBodyScrollTopPosition', scrollPosition)

		scrollLocker.lockScroll(
			scrollPosition,
			!state.isDesktopDevice && state.isMacOrIOS
		)

		commit('lockScroll')
	},

	unlockScroll({ commit, state }) {
		scrollLocker.unlockScroll(
			state.currentBodyScrollTopPosition,
			!state.isDesktopDevice && state.isMacOrIOS
		)
		commit('unLockScroll')
	}
}

const mutations = {
	toggleSidebarVisibility(state) {
		state.isSidebarVisible = !state.isSidebarVisible
	},

	hideSidebar(state) {
		state.isSidebarVisible = false
	},

	addMainError(state, message) {
		if (!message) return

		state.mainErrors = [
			...state.mainErrors,
			{
				message,
				id: uuidv4()
			}
		]
	},

	removeMainError(state, id) {
		state.mainErrors = state.mainErrors.filter(error => error.id !== id)
	},

	showModal(state, { modal, modalData, animation }) {
		const hasModal = state.modalsList.some(item => item.name === modal)

		if (!hasModal) {
			state.modalsList.push({ name: modal, data: modalData, animation })
		}
	},

	hideModal(state, modal) {
		state.modalsList = state.modalsList.filter(item => item.name !== modal)
	},

	hideLastModal(state) {
		state.modalsList = []
		state.modalsList.splice(-1, 1)
	},

	hideAllModals(state) {
		state.modalsList = []
	},

	setIsMobileScreen(state, payload) {
		state.isMobileScreen = payload
	},

	setIsScreenMore575(state, payload) {
		state.isScreenMore575 = payload
	},

	setIsScreenMore480(state, payload) {
		state.isScreenMore480 = payload
	},

	setIsForcedDarkChrome(state, payload) {
		state.isForcedDarkChrome = payload
	},

	setIsDarkFromOS(state, payload) {
		state.isDarkFromOS = payload
	},

	setIsMacOrIos(state, payload) {
		state.isMacOrIOS = payload
	},

	setIsIos(state, payload) {
		state.isIOS = payload
	},

	setIsDesktopDevice(state, payload) {
		state.isDesktopDevice = payload
	},

	setNavAutoScroll(state, val) {
		state.isNavAutoScroll = val
	},

	lockScroll(state) {
		state.isScrollLocked = true
	},

	unLockScroll(state) {
		setTimeout(() => {
			state.isScrollLocked = false
		}, 100)

		state.bodyScrollTopPosition = ''
	},

	setCurrentBodyScrollTopPosition(state, payload) {
		state.currentBodyScrollTopPosition = payload
	},

	setIsChrome(state, payload) {
		state.isChrome = payload
	}
}

const getters = {
	isSidebarVisible: state => {
		return state.isSidebarVisible
	},

	isScrollLocked: state => {
		return state.isScrollLocked
	},

	isDesktopDevice: state => {
		return state.isDesktopDevice
	}
}

export default create(
	{
		namespaced: true,
		state,
		actions,
		mutations,
		getters
	},
	initialState()
)
